import { HCP_SPECIALTY_OTHER } from '@/api/hcp';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { toStringOrNull } from '@/utils/cube';
import { TA_FILTER_LIMIT } from '../../filterDefaultLimits';

const TA_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.hcp_specialty_global_other`],
  limit: TA_FILTER_LIMIT,
});

const hcpOtherSpecialtyFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.hcpOtherSpecialtyLabel',
  sourceCube: HCP_SPECIALTY_OTHER,
  defaultValue: [],
  getOptionsQuery: TA_OPTIONS,
  mapResult: result => {
    const value = toStringOrNull(result[`${HCP_SPECIALTY_OTHER}.hcp_specialty_global_other`]);
    if (value === null) return null;
    return { value, label: value };
  },
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.hcpOtherSpecialtyPlaceholder',
  searchable: true,
  applyFilter: otherSpecialtyValue => {
    let otherFilterValues: string[] = [];

    if (Array.isArray(otherSpecialtyValue)) {
      otherFilterValues = otherSpecialtyValue.filter(
        (entryValue): entryValue is string => typeof entryValue === 'string',
      );
    } else if (typeof otherSpecialtyValue === 'string') {
      otherFilterValues = [otherSpecialtyValue];
    }
    return {
      member: `${HCP_SPECIALTY_OTHER}.hcp_specialty_global_other`,
      operator: 'equals',
      values: [...otherFilterValues],
    };
  },
};

export default hcpOtherSpecialtyFilter;
